var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamondEmojiFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.890625 6.33333L9.77951 17L18.6684 6.33333V5.14815L14.5203 1.59259L9.77951 1L4.44618 1.59259L0.890625 5.14815V6.33333Z",
    fill: "#D9D9D9",
    fillOpacity: 0.2,
    stroke: "#D9D9D9",
    strokeOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondEmojiFill);
export default __webpack_public_path__ + "static/media/diamond-emoji-fill.76d2fb10b9c6f6942d8e28fffa798989.svg";
export { ForwardRef as ReactComponent };